/** @jsx jsx */
import { jsx, Text } from 'theme-ui'
import styled from '@emotion/styled'

const StyledParagraph = styled(Text)``

const CustomParagraph = ({ children, ...props }) => {
  return <StyledParagraph {...props}> {children} </StyledParagraph>
}

export default CustomParagraph
